<template>
  <div>
    <content-loader
      :speed="2"
      primary-color="#f3f3f3"
      secondary-color="#dddddd"
    >
      <rect
        x="0"
        y="0"
        rx="2"
        ry="2"
        width="100%"
        height="20"
      />
      <rect
        x="0"
        y="23"
        rx="2"
        ry="2"
        width="100%"
        height="20"
      />
      <rect
        x="0"
        y="46"
        rx="2"
        ry="2"
        width="100%"
        height="20"
      />
    </content-loader>
  </div>
</template>
<script>
  import { ContentLoader } from 'vue-content-loader'
  export default {
    name: 'LoadingProjectsPlaceholder',
    components: {
      ContentLoader,
    },
  }
</script>
